module.exports = __webpack_public_path__ + "img/3.e3bf0c41.jpg";